/**
 * Created by staffanrantzow on 12/10/16.
 */

import React, { PropTypes } from 'react';
import { CountryService } from 'frilans-finans';
import GeneralError from 'components/general-error/general-error';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';

export class CountryPicker extends React.Component {

  static propTypes = {
    countryName: PropTypes.string,
    defaultValue: PropTypes.string,
    setCountry: PropTypes.func.isRequired,
    useIdAsValue: PropTypes.bool,
    showErrorWithoutBlur: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      countries: this.getInitialOptions(props.countryName),
      selectValue: this.props.countryName || this.props.defaultValue,
      fetchError: false,
      pendingRequest: null
    };

    this.setCountry = this.setCountry.bind(this);
  }

  componentWillMount () {
    this.fetchCountries();
  }

  componentDidMount () {
    this.props.setCountry(this.state.selectValue);
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  getInitialOptions (countryName) {
    let c = [{
      name: proxyCounterpart('PICK_COUNTRY'),
      value: 'default',
      disabled: true
    }];

    if (countryName) {
      c.push({
        disabled: false,
        name: countryName,
        value: countryName
      });
    }

    return c;
  };

  fetchCountries () {
    let pendingRequest = CountryService.get();
    pendingRequest.promise
      .then((countries) => {
        let c = [{
          name: proxyCounterpart('PICK_COUNTRY'),
          value: 'default',
          disabled: true
        }];

        for (let country of countries) {
          c.push({
            disabled: false,
            name: country.name,
            value: (this.props.useIdAsValue) ? country.id : country.name
          });
        }

        this.setState({
          countries: c,
          fetchError: false
        });
      })
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  setCountry (e) {
    this.setState({
      selectValue: e.target.value
    });

    this.props.setCountry(e.target.value);
  }

  renderOption (country, i) {
    return (
      <option
        disabled={country.disabled}
        value={country.value}
        key={i}>
        {country.name}
      </option>
    );
  }

  render () {
    if (this.state.fetchError) {
      return <GeneralError/>;
    }
    if (this.state.countries.length > 0) {
      return (
        <div className="input-wrapper">
          <div className=''>
            <div className='styled-select'>
              <select
                name='country-picker'
                value={this.state.selectValue ? this.state.selectValue : 'default'}
                onChange={this.setCountry}>
                {this.state.countries.map(this.renderOption)}
              </select>
              <label htmlFor="country-picker"><Translate content='COUNTRY'/></label>
            </div>
          </div>
        </div>
      );
    }

    return false;
  }

}

export default CountryPicker;



/** WEBPACK FOOTER **
 ** ./src/components/country-picker/country-picker.js
 **/